const routes = [
    {
        path: "/login",
        name: "login",
        component: () => import("@/view/general/Login"),
        meta: {
            title: "LogIn",
        },
    },
    {
        path: "/signup-invite",
        name: "SignupInvite",
        component: () => import("@/view/general/SignupInvite"),
        meta: {
            title: "SignupInvite",
        },
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        component: () => import("@/view/general/ResetPassword"),
        meta: {
            title: "ResetPassword",
        },
    },
    {
        path: "/reset-OTP",
        name: "ResetOTP",
        component: () => import("@/view/general/ResetOTP"),
        meta: {
            title: "ResetOTP",
        },
    },
    {
        path: "/verify-device",
        name: "VerifyDevice",
        component: () => import("@/view/general/VerifyDevice"),
        meta: {
            title: "VerifyDevice",
            rule: ["admin", "normaluser"],
        },
    },
    {
        path: "/",
        component: () => import("@/view/general/Main"),
        children: [
            {
                path: "/",
                name: "root",
                meta: {
                    title: "root",
                    rule: ["admin", "normaluser"],
                },
            },
            {
                path: "/dashboard",
                name: "dashboard",
                component: () => import("@/view/HomePage"),
                meta: {
                    title: "Dashboards",
                    rule: ["normaluser"],
                },
            },
            {
                path: "/home",
                name: "home",
                component: () => import("@/view/Home"),
                meta: {
                    title: "Home",
                    rule: ["admin", "normaluser"],
                },
            },
            {
                path: "/requestsummary",
                component: () => import("@/view/dashboard/DashboardChart"),
                meta: {
                    title: "RequestSummary",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "dashboardPermission",
                    requiredPermissionName: "RequestSummary",
                    keepAlive: true,
                },
                children: [
                    {
                        path: "",
                        name: "RequestSummary",
                        component: () => import("@/view/dashboard/RequestSummary"),
                        meta: {
                            title: "RequestSummary",
                            rule: ["admin", "normaluser"],
                            requiredPermission: "dashboardPermission",
                            requiredPermissionName: "RequestSummary",
                        },
                    },
                    {
                        path: "",
                        name: "Sampling",
                        component: () => import("@/view/dashboard/Sampling"),
                        meta: {
                            title: "Sampling",
                            rule: ["admin", "normaluser"],
                            requiredPermission: "dashboardPermission",
                            // requiredPermissionName: "Sampling"
                        },
                    },
                    {
                        path: "",
                        name: "Report",
                        component: () => import("@/view/dashboard/Report"),
                        meta: {
                            title: "Report",
                            rule: ["admin", "normaluser"],
                            requiredPermission: "dashboardPermission",
                            // requiredPermissionName: "Report"
                        },
                    },
                ],
            },
            {
                path: "/requestanalyze",
                name: "Requestanalyze",
                component: () => import("@/view/dashboard/RequestAnalyze"),
                meta: {
                    title: "RequestAnalyze",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "dashboardPermission",
                    requiredPermissionName: "RequestAnalyze",
                },
            },
            {
                path: "/trendinganalyze",
                name: "TrendingAnalyze",
                component: () => import("@/view/dashboard/TrendingAnalyze"),
                meta: {
                    title: "TrendingAnalyze",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "dashboardPermission",
                    requiredPermissionName: "TrendingAnalyze",
                },
            },
            {
                path: "/originlatency",
                name: "OriginLatency",
                component: () => import("@/components/DynamicComponent"),
                props: {
                    componentName: "OriginLatency",
                    title: "ORIGIN LATENCY",
                    description: "this is origin latency",
                    isCheckPlanFeature: true,
                    featureName: "ORIGIN_LATENCY_VIEW",
                },
                meta: {
                    title: "OriginLatency",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "dashboardPermission",
                    requiredPermissionName: "OriginLatency",
                },
            },
            {
                path: "/netflowanalyze",
                name: "NetflowAnalyze",
                component: () => import("@/view/dashboard/NetflowAnalyze"),
                meta: {
                    title: "NetflowAnalyze",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "dashboardPermission",
                    requiredPermissionName: "NetflowAnalyze",
                },
            },
            {
                path: "/customize-dashboard",
                // name: "CustomizeDashboard",
                props: {
                    componentName: "CustomizeDashboard",
                    title: "CustomizeDashboard",
                },
                meta: {
                    title: "CustomizeDashboard",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "dashboardPermission",
                    requiredPermissionName: "CustomizeDashboard",
                },
                children: [
                    {
                        path: "",
                        redirect: "1", // default child path
                    },
                ],
            },
            {
                path: "/customize-dashboard/:dashboardName",
                component: () => import("@/view/dashboard/CustomizeDashboard"),
                props: {
                    componentName: "CustomizeDashboard",
                    title: "CustomizeDashboard",
                },
                meta: {
                    title: "CustomizeDashboard",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "dashboardPermission",
                    requiredPermissionName: "CustomizeDashboard",
                },
            },
            {
                path: "/ddos-analyze",
                name: "IntelligentProtection",
                component: () => import("@/view/dashboard/IntelligentProtection"),
                meta: {
                    title: "IntelligentProtection",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "intelligentProtectionPermission",
                    requiredPermissionName: "DDoSAnalyze",
                },
            },
            {
                path: "/behavior-analyze",
                name: "BehaviorAnalyze",
                component: () => import("@/view/dashboard/BehaviorAnalyze"),
                meta: {
                    title: "BehaviorAnalyze",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "intelligentProtectionPermission",
                    requiredPermissionName: "BehaviorAnalyze",
                },
            },
            {
                path: "/fqdn-config",
                // name: "FQDNConfig",
                component: () => import("@/view/FQDNConfig/Page"),
                meta: {
                    title: "FQDNConfig",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "FQDNConfig",
                    keepAlive: true,
                },
                children: [
                    {
                        path: "",
                        redirect: "app-profile", // default child path
                    },
                    {
                        path: "app-profile",
                        name: "AppProfile",
                        component: () => import("@/view/AppProfile/Page"),
                        meta: {
                            title: "AppProfile",
                            rule: ["admin", "normaluser"],
                            requiredPermission: "domainManagePermission",
                            requiredPermissionName: "FQDNConfig",
                            keepAlive: true,
                        },
                    },
                    {
                        path: "domainsetting",
                        name: "NoneProfileDomainSetting",
                        component: () => import("@/view/NoneProfileDomainSetting/Page"),
                        meta: {
                            title: "DomainManage",
                            rule: ["admin", "normaluser"],
                            requiredPermission: "domainManagePermission",
                            requiredPermissionName: "FQDNConfig",
                            keepAlive: true,
                        },
                    },
                ],
            },
            {
                path: "/fqdn-config/app-profile/:appProfileName",
                name: "ProfileDomain",
                component: () => import("@/view/ProfileDomain/Page"),
                beforeEnter: (to, from, next) => {
                    if (!to.query.groupName || to.query.groupName == "all") next({ name: "AppProfile" });
                    else next();
                },
                meta: {
                    title: "ProfileDomain",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "FQDNConfig",
                    keepAlive: true,
                },
            },
            {
                path: "/wafrules",
                name: "WafRules",
                component: () => import("@/view/WafRules/Page"),
                meta: {
                    title: "WafRules",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "WafRules",
                    keepAlive: true,
                },
            },
            {
                path: "/wafrules/rate-limit-token-playground",
                name: "ExplainWafRateLimitToken",
                component: () => import("@/components/PoptipInfos/ExplainWafRateLimitToken"),
                meta: {
                    title: "WafRules",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "WafRules",
                    keepAlive: true,
                },
            },
            {
                path: "/certsmanage",
                name: "CertsUpload",
                component: () => import("@/view/CertsManage/Page"),
                meta: {
                    title: "CertsManage",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "CertsUpload",
                    keepAlive: true,
                },
            },
            {
                path: "/wafevent",
                name: "WafEvents",
                component: () => import("@/view/WafEvent/Page"),
                meta: {
                    title: "WafEvents",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "WafEvents",

                    keepAlive: true,
                },
            },
            {
                path: "/origin-policies",
                name: "OriginPolicies",
                component: () => import("@/components/DynamicComponent"),
                props: {
                    componentName: "OriginPolicy",
                    title: "ORIGIN POLICY",
                    description: "this is origin policies",
                    isCheckPlanFeature: true,
                    featureName: "ORIGIN_POLICY",
                },
                meta: {
                    title: "OriginPolicies",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "OriginPolicies",
                    keepAlive: true,
                },
            },
            {
                path: "/html-pages",
                name: "HtmlPages",
                component: () => import("@/components/DynamicComponent"),
                props: {
                    componentName: "HtmlPages",
                    title: "HTML PAGE",
                    description: "this is custom html pages",
                    isCheckPlanFeature: true,
                    featureName: "CUSTOM_PAGE",
                },
                meta: {
                    title: "HtmlPages",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "HtmlPages",
                    keepAlive: true,
                },
            },
            {
                path: "/OWASP",
                name: "OWASP",
                component: () => import("@/components/DynamicComponent"),
                props: {
                    componentName: "OWASP",
                    title: "OWASP",
                    description: "this is owasp rule",
                    isCheckPlanFeature: true,
                    featureName: "CUSTOM_PAGE",
                },
                meta: {
                    title: "OWASP",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "OWASP",
                    keepAlive: true,
                },
            },
            {
                path: "/alertrules",
                name: "AlertRules",
                component: () => import("@/components/DynamicComponent"),
                props: {
                    componentName: "AlertRules",
                    title: "LOG ALERT",
                    description: "this is log alert",
                    isCheckPlanFeature: true,
                    featureName: "LOG_ALERT",
                },
                meta: {
                    title: "AlertRules",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "AlertRules",
                    keepAlive: true,
                },
            },
            {
                path: "/notificationchannels",
                name: "NotificationChannels",
                component: () => import("@/components/DynamicComponent"),
                props: {
                    componentName: "NotificationChannels",
                    title: "LOG ALERT (Notification Channels)",
                    description: "this is log alert",
                    isCheckPlanFeature: true,
                    featureName: "LOG_ALERT",
                },
                meta: {
                    title: "NotificationChannels",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "domainManagePermission",
                    requiredPermissionName: "NotificationChannels",
                    keepAlive: true,
                },
            },
            {
                path: "/groupresource",
                name: "",
                component: () => import("@/view/GroupResource/Page"),
                meta: {
                    title: "GroupResource",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "GroupResource",
                    keepAlive: true,
                },
            },
            {
                path: "/recordline-groups",
                name: "RecordLineGroups",
                component: () => import("@/view/RecordLineGroups/Page"),
                meta: {
                    title: "RecordLineGroups",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "RecordLineGroups",
                    keepAlive: true,
                },
            },
            {
                path: "/servicegroup",
                name: "ServiceGroup",
                component: () => import("@/view/ServiceGroup/Page"),
                meta: {
                    title: "ServiceGroup",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "ServiceGroup",
                    keepAlive: true,
                },
            },
            {
                path: "/subscription",
                name: "Subscription",
                component: () => import("@/view/Subscription"),
                meta: {
                    title: "Subscription",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "Subscription",
                    keepAlive: true,
                },
            },
            {
                path: "/slbsetting",
                name: "SlbsManage",
                component: () => import("@/view/SlbSetting/Page"),
                meta: {
                    title: "SlbsManage",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "SlbsManage",
                    keepAlive: true,
                },
            },
            {
                path: "/virtualslbsetting",
                name: "VirtualSlbsManage",
                component: () => import("@/view/VirtualSlbSetting/Page"),
                meta: {
                    title: "VirtualSlbsManage",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "VirtualSlbsManage",
                    keepAlive: true,
                },
            },
            {
                path: "/edgesetting",
                name: "EdgesManage",
                component: () => import("@/view/EdgeSetting/Page"),
                meta: {
                    title: "EdgesManage",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "EdgesManage",
                    keepAlive: true,
                },
            },
            {
                path: "/probesetting",
                component: () => import("@/view/ProbeSetting/Page"),
                meta: {
                    title: "ProbesManage",
                    rule: ["admin"],
                    keepAlive: true,
                },
            },
            {
                path: "/tasks",
                component: () => import("@/view/monitor/Tasks"),
                meta: {
                    title: "TasksSearch",
                    rule: ["admin"],
                    keepAlive: true,
                },
            },
            {
                path: "/hardwarestatus",
                component: () => import("@/view/monitor/HardwareStatus"),
                meta: {
                    title: "HardwareStatus",
                    rule: ["admin"],
                },
            },
            {
                path: "/certsapply",
                component: () => import("@/view/monitor/CertsApply"),
                meta: {
                    title: "CertsApply",
                    rule: ["admin"],
                    keepAlive: true,
                },
            },
            {
                path: "/account-info",
                // name: "accountinfo",
                component: () => import("@/view/general/AccountInfo"),
                meta: {
                    title: "AccountInfo",
                    rule: ["admin", "normaluser"],
                },
                children: [
                    {
                        path: "",
                        redirect: "user", // default child path
                    },
                    {
                        path: "user",
                        name: "UserInfo",
                        component: () => import("@/view/general/AccountInfo/userInfo"),
                        meta: {
                            title: "UserInfo",
                            rule: ["admin", "normaluser"],
                        },
                    },
                    {
                        path: "security",
                        name: "Security",
                        component: () => import("@/view/general/AccountInfo/security"),
                        meta: {
                            title: "Security",
                            rule: ["admin", "normaluser"],
                        },
                    },
                    {
                        path: "payment",
                        name: "Payment",
                        component: () => import("@/view/general/AccountInfo/payment.vue"),
                        meta: {
                            title: "Payment",
                            rule: ["admin", "normaluser"],
                            requiredPermission: "billingPermission",
                            requiredPermissionName: "Billing",
                            keepAlive: true,
                        },
                    },
                ],
            },
            {
                path: "/logout",
                name: "logout",
                component: () => import("@/view/general/Logout"),
                meta: {
                    title: "LogOut",
                    rule: ["admin", "normaluser"],
                },
            },
            {
                path: "/usersmanage",
                name: "UsersManage",
                component: () => import("@/view/UsersManage/Page"),
                meta: {
                    title: "UsersManage",
                    rule: ["admin", "normaluser"],
                    keepAlive: true,
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "UsersManage",
                },
            },
            {
                path: "/rolesmanage",
                name: "RolesManage",
                component: () => import("@/view/RolesManage/Page"),
                meta: {
                    title: "RolesManage",
                    rule: ["admin", "normaluser"],
                    keepAlive: true,
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "RolesManage",
                },
            },
            {
                path: "/frontendsetting",
                name: "system",
                component: () => import("@/view/system/FrontEndSetting"),
                meta: {
                    title: "FrontEndSetting",
                    rule: ["admin"],
                },
            },
            {
                path: "/backendsetting",
                name: "BackendSetting",
                component: () => import("@/view/system/BackEndSetting"),
                meta: {
                    title: "BackEndSetting",
                    rule: ["admin"],
                },
            },
            {
                path: "/group-pattern",
                name: "GroupPattern",
                component: () => import("@/view/GroupPattern/Page"),
                meta: {
                    title: "GroupPattern",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "GroupPattern",
                },
            },
            {
                path: "/group-api-keys",
                name: "ApiKeys",
                component: () => import("@/view/ApiKeys/Page"),
                meta: {
                    title: "ApiKeys",
                    rule: ["admin", "normaluser"],
                    requiredPermission: "groupResourcesPermission",
                    requiredPermissionName: "ApiKeys",
                },
            },
            // {
            //     path: "/test",
            //     name: "test",
            //     component: () => import("@/view/Test"),
            //     meta: {
            //         title: "Test",
            //         rule: ["admin"],
            //     },
            // },
            {
                path: "*",
                name: "error_404",
                component: () => import("@/view/general/404"),
                meta: {
                    title: "Error404",
                    rule: ["admin", "normaluser"],
                },
            },
        ],
    },

    /* 因統整代碼,所以先將沒用到的或是有疑慮的頁面功能回收 */
    // {
    //     path: "/ssh-keys",
    //     name: "sshkeys",
    //     component: () => import("@/view/SSHKeysManage/Page"),
    //     meta: {
    //         title: "SSHKeysManage",
    //         rule: ["admin"],
    //     },
    // },
    // {
    //     path: "/system-manage/nodes-connect",
    //     component: () => import("@/view/NodesConnect/Page"),
    //     meta: {
    //         title: "NodesConnect",
    //         rule: ["admin"],
    //         keepAlive: true,
    //         requiredPermission: "groupResourcesPermission",
    //     },
    // },
    // {
    //     path: "/scrolls",
    //     name: "Scrolls",
    //     // component: () => import("@/components/DynamicComponent"),
    //     component: () => import("@/view/InodeStorage/Page"),
    //     props: {
    //         componentName: "Scrolls",
    //         title: "Scrolls",
    //         description: "this is custom html pages",
    //         isCheckPlanFeature: true,
    //         featureName: "CUSTOM_PAGE",
    //     },
    //     meta: {
    //         title: "Scrolls",
    //         rule: ["admin", "normaluser"],
    //         requiredPermission: "domainManagePermission",
    //         requiredPermissionName: "HtmlPages",
    //         keepAlive: true,
    //     },
    // },
    // {
    //     path: "/ninjasetting",
    //     name: "NinjasManage",
    //     component: () => import("@/view/NinjaSetting/Page"),
    //     meta: {
    //         title: "NinjasManage",
    //         rule: ["admin", "normaluser"],
    //         requiredPermission: "groupResourcesPermission",
    //         requiredPermissionName: "NinjasManage",
    //         keepAlive: true,
    //     },
    // },
    // {
    //     path: "/test",
    //     name: "test",
    //     component: () => import("@/view/Test"),
    //     meta: {
    //         title: "Test",
    //         rule: ["admin"],
    //     },
    // },
    // {
    //     path: "/systemlog",
    //     component: () => import("@/view/monitor/SystemLog"),
    //     meta: {
    //         title: "SystemLog",
    //         rule: ["admin"],
    //         keepAlive: true,
    //     },
    // },
];

// if (process.env.NODE_ENV == "development") {
//     routes[3].children.unshift({
//         path: "/test",
//         name: "test",
//         component: () => import("@/view/Test"),
//         meta: {
//             title: "Test",
//             rule: ["normaluser", "admin"]
//         }
//     });
// }

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js